export const KENTICO_TYPES = {
  OUR_TEAM: 'our_team',
  PROMO_SECTION: 'promosection',
  GRID: 'grid',
  CIRCLE_FEATURE_CARD: 'circle_feature_item',
  EMPLOYEE_BOX: 'employee',
  NAVBAR: 'navbar',
  DROPDOWN_LIST: 'drop_down_list',
  INTERNAL_LINK: 'internal_link',
  IMAGE_TITLE_DESCRIPTION: 'image_title_description_item',
  CAROUSEL_OF_ITEMS: 'carousel_of_items',
  CAROUSEL_OF_IMAGES: 'carousel_of_images',
  ITEMS_IN_ROW: 'items_in_row',
  CONTACT: 'contact',
  EMPLOYEES_COLLECTION: 'employees_collection',
  TWO_COLUMN_GRID: 'two_column_grid',
  THREE_COLUMN_GRID: 'three_column_grid',
  FOUR_COLUMN_GRID: 'four_column_grid',
  BUTTON: 'button',
  PAGE_SECTION: 'page_section',
  TEXT: 'text',
  IMAGE_WITH_LINK: 'image_feature_with_link',
  TEXT_FEATURE_WITH_DESCRIPTION: 'text_feature_with_description',
  BLOG_ARTICLES_LIST: 'ui_blog_articleslist',
  CASE_STUDY_LIST: 'case_study_list',
  IMAGE_WITH_TEXT: 'ui_image_with_text',
  HERO_WITH_VIDEO: 'hero_with_video',
  HEADLINE_WITH_DESCRIPTION: 'headline_with_description',
  OFFICE: 'office',
  OPINION: 'opinion',
  FEATURED_SECTION: 'ui_blog_featured_section',
  QUOTE_WITH_IMAGE: 'quote_with_image',
  PROGRESS_STEPS: 'progress_steps',
  AWARD_WITH_STARS_AND_IMAGE: 'award_with_stars_and_image',
  TABS_MENU: 'tabs_menu',
  ARCH_LINE_SECTION: 'arch_line_section',
  IMAGE_WITH_BUTTON: 'image_with_button',
  INPUT_TEXT: 'input_text',
  FORM_EMAIL_WITH_SUBMIT: 'form_email_with_submit',
  ACCORDION: 'accordion',
  LATEST_ARTICLES: 'latest_articles',
  FOOTER_LINKS_COLUMN: 'footer_links_column',
  SOCIAL_MEDIA_PANEL: 'social_media_panel',
  OUR_TEAM_PHOTOS_LINK: 'our_team_photos_link',
  PROCESS_ICONS: 'process_icons',
  STATIC_PAGE_JUMBOTRON: 'static_page_jumbotron',
  ICON_WITH_TEXT_SECTION: 'icon_with_text',
  SECTION_HEADER: 'section_header',
  MAIN_HERO: 'main_hero',
  LINK_BOX: 'link_box',
  AWARD: 'award',
  SIDE_NAV_SLIDER: 'side_nav_slider',
  TWO_COLOR_SECTION_WITH_IMAGE: 'two_color_section_with_image',
  ICON_HEADER: 'icon_header',
  ARTICLE_PARAGRAPH: 'article_paragraph',
  TEXT_BLOCK_SCHEMA: 'text_block_schema',
  CHAPTER: 'chapter',
  STICKY_SECTIONS_WRAPPER: 'sticky_sections_wrapper',
  QUOTE: 'quote',
  CONTACT_EMPLOYEE: 'contact_employee',
  CASE_STUDY_NEXT: 'case_study_next',
  LATEST_CASE_STUDIES: 'latest_case_studies',
  TWO_COLOR_HEADER: 'two_color_header',
  BLOG_HERO: 'blog_hero',
  FEATURED_ARTICLES: 'featured_articles',
  DOWNLOAD_WITH_IMAGE: 'download_with_image',
  TEXT_WITH_IMAGE_OUTSIDE: 'text_with_image_outside',
  BLOG_AUTHOR_LIST: 'blog_authors_list',
  PAGE_BACK_LINK: 'page_back_link',
  ICON_WITH_DESCRIPTION: 'icon_with_description_value',
  CAREER_HERO: 'career_hero',
  ACTIVE_JOB_OFFERTS: 'active_job_offerts',
  PROCESS_BOXES: 'process_boxes',
  TEXT_EMAIL_BUTTON_FORM: 'text_email_button',
  VIDEO_LIST: 'video_list',
  FORM_COMPONENT: 'form',
  CTA_BUTTON: 'ui_ctabutton',
  HIGHLIGHTED_FIELD: 'ui_highlitedfield',
  EMBEDEDDED_VIDEO: 'ui_embeddedvideo'
};

export const KENTICO_SOCIALMEDIA_CODES = {
  LINKEDIN: 'linkedin',
  UPWORK: 'upwork',
  EMAIL: 'e_mail',
  FACEBOOK: 'facebook',
  SKYPE: 'skype'
};
